import { StrictMode, createContext, useContext } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../js/api/queryClient";
import { AllActivityFeedWrapper } from "./components/activity-feed/all-activity-feed-wrapper";

const AllActivityFeedContext = createContext();
export const useAllActivityFeed = () => useContext(AllActivityFeedContext);
function AllActivityFeedProvider({ data, children }) {
  return (
    <AllActivityFeedContext.Provider value={data}>
      {children}
    </AllActivityFeedContext.Provider>
  );
}

function AllActivityFeedRenderer() {
  const elements = document.querySelectorAll(".react-all-activity-feed");
  if (!elements) return;
  elements.forEach((element) => {
    let initialProps = {};
    try {
      initialProps = JSON.parse(element.getAttribute("data-initial-props"));
    } catch (error) {
      console.error(
        error,
        "Could not parse initial props JSON for ActivityFeed"
      );
    }

    createRoot(element).render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <AllActivityFeedProvider data={initialProps}>
            <AllActivityFeedWrapper />
          </AllActivityFeedProvider>
        </QueryClientProvider>
      </StrictMode>
    );
  });
}

export const initAllActivityFeed = () => {
  if (document.readyState !== "loading") {
    AllActivityFeedRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", AllActivityFeedRenderer);
  }
};
